<ng-container *ngIf="!customToggle">
  <shared-ui-buttons-button [icon]="icon" [type]="type" [styleClass]="styleClass" (click)="toggleMenu($event)" [iconSize]="iconSize"> </shared-ui-buttons-button>
</ng-container>

<ng-container *ngIf="customToggle">
  <div (click)="toggleMenu($event)">
    <ng-content select="[dropdownToggle]"></ng-content>
  </div>
</ng-container>

<p-menu #menu [popup]="true" [model]="buttonOptions" [appendTo]="appendTo">
  <ng-template #item let-item>
    <a pRipple class="p-menu-item-link d-flex gap-2 py-2" [ngClass]="{ 'border-bottom mb-1': !!item.description }">
      <span [class]="item.icon"></span>
      <div>
        <span [ngClass]="{ 'fw-bold': !!item.description }">{{ item.label }}</span>
        <br *ngIf="item.description" />
        <span *ngIf="item.description" class="fw-bold small text-secondary opacity-50">
          {{ item.description }}
        </span>
      </div>
    </a>
  </ng-template>
</p-menu>
